import { postJsMessage } from '../../bridge';
import API from '../../api';
import { PostMessageOption } from '../../types';
import { ERROR_CODE, genError, isAvailable } from '../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';
import type { HttpRequest, HttpResponse } from './types';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * http.request
 *
 * [PLATFORM]
 * mac        6.2.5+
 * windows    6.2.5+
 * linux      6.2.5+
 * ios        6.2.5+
 * android    6.2.5+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function request(
  params: HttpRequest,
  options?: PostMessageOption
) {
  await isAvailable('http.request');
  const { url, method = 'GET' } = params;

  if (url) {
    return postJsMessage<
      HttpRequest,
      Promise<NativeAPIResponseMessage<HttpResponse>>
    >(API.request, { ...params, method }, options);
  } else {
    return Promise.reject(
      genError({
        errorCode: ERROR_CODE.REQUEST_PARAM_ERROR,
        apiName: API.request,
        message: `url can't be empty!`,
      })
    );
  }
}

export default {
  request,
};
